import type { DaycareHotelMode } from "@/hooks/useDaycareHotelAccess";

export function getPetStayNotesLabelKey(mode: DaycareHotelMode): string {
  switch (mode) {
    case "daycare":
      return "petProfile.notesDaycare";
    case "hotel":
      return "petProfile.notesHotel";
    case "both":
      return "petProfile.notesDaycareHotel";
    case "none":
      return "petProfile.extraNotes";
  }
}
